import React from 'react'
import PropTypes from 'prop-types'

import Ausbildungsnachweis from '../svg/icons/Ausbildungsnachweis'

class File extends React.Component {
  render() {
    const {status} = this.props
    const {canVerify} = this.props
    let style = 'file'

    switch (status) {
      case 'active':
        style += ' file--active'
        break
      case 'new':
        style += ' file--new'
        break
      case 'submitted':
        if (canVerify) {
          style += ' file--new'
        }
        style += ' file--submitted'
        break
      case 'error':
        style += ' file--error'
        break
      default:
        break
    }

    return (
      <div className={style}>
        <Ausbildungsnachweis hasComment={this.props.hasComment} />
        <div className="file__id">{`AN ${this.props.id}`}</div>
      </div>
    )
  }
}

File.propTypes = {
  id: PropTypes.number,
  status: PropTypes.string,
  canVerify: PropTypes.bool,
  hasComment: PropTypes.bool,
}

export default File
